import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Filter, toFilterXml } from '../../dataObjects/Filter';
import { Order, toOrderXml } from '../../dataObjects/Order';

export interface IListComponentCategoriesRequest extends IBaseRequest {
    timestamp?: string;
    limit?:     string;
    offset?:    string;
    orderBy?:   string;
    FILTER?:    Filter;
    ORDER?:     Order;
}

export class ListComponentCategoriesRequest extends BaseRequest implements IListComponentCategoriesRequest {

    public timestamp?: string;
    public limit?:     string;
    public offset?:    string;
    public orderBy?:   string;
    public FILTER?:    Filter;
    public ORDER?:     Order;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.timestamp = otherOptions.timestamp;
    this.limit = otherOptions.limit;
    this.offset = otherOptions.offset;
    this.orderBy = otherOptions.orderBy;
    this.FILTER = otherOptions.FILTER;
    this.ORDER = otherOptions.ORDER;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.timestamp, 'timestamp');
    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    if (this.FILTER) parameters += toFilterXml(this.FILTER);
    if (this.ORDER) parameters += toOrderXml(this.ORDER);

    return super.wrapperXml('ListComponentCategories', parameters);
  }
}
